import styled from "styled-components";
import css from "@styled-system/css";
import { Card, Box, Typography, Icon } from "@bca/ui-library";

import { SpecificationItem } from "./VehicleSpecification";
import CalendarSVG from "../components/Icons/CalendarSVG";
import HistorySVG from "../components/Icons/HistorySVG";
import MOTSVG from "../components/Icons/MOTSVG";
import TachometerFastSolidSVG from "./Icons/TachometerFastSolidSVG";
import { formatCount } from "../helpers/formatCount";

interface ServiceHistoryProps {
  serviceHistory: string;
  lastServiceDate: string;
  MOTExpiryDate: string;
  lastServiceMileage: number;
  serviceCount: {
    total: number;
    mainDealer: number;
  };
  dvsaMileage?: any;
  notes?: string;
}

const ServiceHistoryCard = styled(Card)`
  ${css({
    minWidth: ["100%", "100%", "427px"],
    width: ["100%", "427px"],
    height: "fit-content",
    marginRight: 0,
    marginLeft: [0, 0, 0],
    marginBottom: "44px",
    "& > div > div": {
      width: ["50%", "33%", "50%", "50%"],
      marginBottom: [6, 7],
    },
    paddingBottom: 0,
  })}
  @media screen and (max-width: 1038px) {
    margin-top: 0px;
  }
  @media screen and (min-width: 1039px) {
    margin-top: 44px;
  }
`;

const ServiceHistory: React.FunctionComponent<ServiceHistoryProps> = ({
  serviceHistory,
  lastServiceDate,
  MOTExpiryDate,
  lastServiceMileage,
  serviceCount,
  dvsaMileage,
  notes,
}) => {
  const numberOfServices = Boolean(serviceCount)
    ? serviceCount?.mainDealer > 0 || serviceCount?.total > 0
      ? `${serviceCount?.total} (${serviceCount?.mainDealer} main dealer)`
      : "-"
    : "-";

  const getNotes = () => {
    if (!notes) {
      return "No notes recorded";
    }

    return notes;
  };

  return (
    <ServiceHistoryCard title="Service History">
      <Typography variant="h5" textAlign="left" my={0} css={css}>
        Service History
      </Typography>
      <Box display="flex" flexWrap="wrap" marginTop={[5, 7]}>
        <SpecificationItem label="Service History" value={serviceHistory}>
          <HistorySVG
            width={18}
            height={18}
            marginX={0}
            display="inline-flex;"
          />
        </SpecificationItem>
        <SpecificationItem label="Number of services" value={numberOfServices}>
          <Icon
            name="wrench"
            weight="solid"
            color="footer-blue"
            width="18px"
            height="18px"
          />
        </SpecificationItem>
        <SpecificationItem label="Last Service" value={lastServiceDate}>
          <CalendarSVG
            width={16}
            height={18}
            marginX={0}
            display="inline-flex;"
          />
        </SpecificationItem>
        <SpecificationItem
          label="Last service mileage"
          value={
            Boolean(lastServiceMileage) ? formatCount(lastServiceMileage) : "-"
          }
        >
          <TachometerFastSolidSVG
            width={18}
            height={18}
            marginX={0}
            display="inline-flex;"
          />
        </SpecificationItem>
        <SpecificationItem
          fullWidth
          label="DVSA mileage"
          value={Boolean(dvsaMileage) ? dvsaMileage : "-"}
          height="auto"
        >
          <TachometerFastSolidSVG
            width={18}
            height={18}
            marginX={0}
            display="inline-flex;"
          />
        </SpecificationItem>
        <SpecificationItem
          fullWidth
          label="Additional service notes"
          value={getNotes()}
        >
          <Icon
            name="note"
            weight="solid"
            width={20}
            height={17}
            marginX={0}
            color="black"
          />
        </SpecificationItem>
        <SpecificationItem fullWidth label="MOT Expiry" value={MOTExpiryDate}>
          <MOTSVG width={20} height={17} marginX={0} display="inline-flex;" />
        </SpecificationItem>
      </Box>
    </ServiceHistoryCard>
  );
};

export default ServiceHistory;
